import classNames from 'classnames';
import qrcode from 'qrcode-generator';
import { useMemo } from 'react';

/** A link as a QR code, dark on white on both themes: cameras read dark modules on light. */
const QrCode = ({ link, label, className }: { link: string; label: string; className?: string }) => {
  const svg = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(link);
    qr.make();
    return qr.createSvgTag({ cellSize: 6, margin: 2, scalable: true });
  }, [link]);
  return <div role="img" aria-label={label} className={classNames('rounded-lg bg-white p-3', className)} dangerouslySetInnerHTML={{ __html: svg }} />;
};

export default QrCode;
